import { useDataModelStore } from "./dataModel";
import { usePaginatedListStore } from "./paginatedList";
import VueApiQueryList from "@/models/lists/VueApiQueryList";
import Account from "@/models/Account";
import Homework from "@/models/Homework";
import User from "@/models/User";
import AssignedHomework from "@/models/AssignedHomework";
import CompletedHomework from "@/models/CompletedHomework";

const HomeworkModelBuilder = function({account_id}) {

    if (!account_id) {
        throw new Error("no account");
    }

    let account = new Account({ id: account_id });
    return new Homework().for(account);
};

const CompletedWorkBuilder = function({ homeworkId, for_user}, context, {account_id }) {
    if (!account_id || !for_user) {
        throw new Error("no account or userId");
    }

    if (!homeworkId) {
        throw new Error("no homeworkId");
    }

    let account = new Account({ id: account_id });
    let user = new User({ id: for_user });
    let homework = new Homework({ id: homeworkId });
    return new CompletedHomework().for(account, homework, user);
};

const AccUserHomework = new VueApiQueryList(function(id, context, extra) {
    let accountId = extra?.account_id;
    if (!accountId) {
        throw new Error("no account");
    }

    let account = new Account({ id: accountId });
    switch(context){
        case "user": {
            let user = new User({ id: id });
            return new Homework().for(account, user);
        }
        case 'account': {
            return new Homework().for(account);
        }
        default:
            throw new Error("unknown context");
    }
}, HomeworkModelBuilder);



const HomeworkCompletedWork = new VueApiQueryList(
    CompletedWorkBuilder,
    CompletedWorkBuilder
);

const UserAssignedHomework = new VueApiQueryList(
    function(id, context, { account_id }) {
        if (!account_id || !id) {
            throw new Error("no account or userId");
        }

        let account = new Account({ id: account_id });
        let user = new User({ id: id });
        return new AssignedHomework().for(account, user);
    },
    HomeworkModelBuilder
);

export const useAssignedHomeworkStore = useDataModelStore('assignedHomework', UserAssignedHomework);
export const useHomeworkStore = useDataModelStore('homework', AccUserHomework);
export const useWorkItemsStore = useDataModelStore('workItems', HomeworkCompletedWork);

export const useLatestHomeworkStore = usePaginatedListStore("latestHomework", useHomeworkStore);
export const useAssignedHomeworkListStore = usePaginatedListStore("assignedHomeworkList", useAssignedHomeworkStore);
